import { Injectable } from '@angular/core';
import { CaiApi } from '../../utils/cai-api';
import { ISurcharges } from '../../model/surcharges.model';
import { API_CORE } from '../../constant/api-core.const';

@Injectable({
  providedIn: 'root',
})
export class SurchargeService {
  getSurcharges(
    airline: string,
    destinationAirport: string,
    token?: string,
  ): Promise<ISurcharges[]> {
    const extraOptions: any = {
      queryParams: {
        airline,
        destinationAirport,
      },
    };
    if (token) {
      extraOptions.queryParams.token = token;
    }
    return CaiApi.get(
      API_CORE.name,
      API_CORE.URLs.Surcharge.Surcharges,
      extraOptions,
    );
  }
}
